<app-close-btn (toggle)="closeModal()"></app-close-btn>
<div class="resizer" *ngIf="popupClass === 'resize'" resizer></div>
<ng-content></ng-content>


